export * from './post-bericht.component';
export * from './post-bericht.component.module';